import IconNavItem from './IconNavItem';
import styled from 'styled-components';
import { faCoffee, faHamburger } from "pro-solid-svg-icons";
import {
    useLocation, Link
} from "react-router-dom";
import { up } from 'styled-breakpoints';


const IconNavWrap = styled.div`
    display: flex;
    width: auto;
    justify-content: space-between;
    font-size: 1em;

    ${up('md')} {
        font-size: 0.85em;
    }

    ${up('lg')} {
        font-size: 0.9em;
    }

    ${up('xxl')} {
        font-size: 1em;
    }

`;

const IconNav = props => {

    let location = useLocation();

    return (
      <IconNavWrap>
        <Link to="create-menu" title="Menu Builder Step One">
          <IconNavItem icon={faCoffee} active={location.pathname === '/menu-builder/visual-menu/create-menu' ? true : false} />
        </Link>
        {/* <Link to={`${url}/create-categories`} title='Menu Builder Step Two'>
                <IconNavItem
                    icon={faCoffee}
                    active={location.pathname === `${url}/create-categories` ? true : false}
                />
            </Link> */}
        <Link to='create-items' title="Menu Builder Step Three">
          <IconNavItem icon={faHamburger} active={location.pathname === '/menu-builder/visual-menu/create-items' ? true : false} />
        </Link>
      </IconNavWrap>
    );
}

export default IconNav;
